
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2.0833333333333335,0,0,2.0833333333333335,0,0)"}},[_c('path',{attrs:{"d":"M12.75,12.75H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5v6","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M5.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M17.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M14.250 15.750 L23.250 15.750 L23.250 23.250 L14.250 23.250 Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M18.75,11.25h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,18.75,11.25Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M18.75,19.154a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    